import { JourneyTypeEnum } from '../journeys/types';
import { FeatureAccess } from '../../config/companyFeatures';

export enum SalesModelEnum {
  CaaS = 'Cooling as a Service',
  Lease = 'Lease',
  Sample = 'Sample',
}

export interface CustomKitting {
  name: string;
}

export interface CompanyEntity {
  _id: string;
  companyName: string;
  salesModel: SalesModelEnum;
  defaultJourneyType: JourneyTypeEnum;
  kittings?: CustomKitting[];
  orgType?: string;
  parentCompany?: string;
  // Feature Access: which gated screens Artyc has granted this company.
  featureAccess?: FeatureAccess;
  // Company-wide toggle for the Field Personnel feature.
  fieldPersonnelEnabled?: boolean;
  // IANA timezone used to render customer-facing dates (emails). Defaults to
  // America/Los_Angeles when unset.
  timezone?: string;
}

export interface CompanyFilters {
  search?: string;
}
